module.exports = __webpack_public_path__ + "static/img/ship-transport_256.e3de617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ship-transport_256.png
// module id = m6fk
// module chunks = 0